/**

 * Options checks for scanner v2 — earnings is info-only (never optionsBlock).

 */



import { isEarningsEquity } from "./equitySymbol.js";



const IV_HISTORY_KEY = "auctus_atm_iv_history";



export function loadIvHistory() {

  try {

    if (typeof localStorage === "undefined") return {};

    return JSON.parse(localStorage.getItem(IV_HISTORY_KEY) || "{}");

  } catch {

    return {};

  }

}



export function saveIvDaily(symbol, atmIv) {

  if (symbol == null || atmIv == null || typeof localStorage === "undefined") return;

  const hist = loadIvHistory();

  const sym = String(symbol).toUpperCase();

  const day = new Date().toISOString().slice(0, 10);

  if (!hist[sym]) hist[sym] = {};

  hist[sym][day] = atmIv;

  try {

    localStorage.setItem(IV_HISTORY_KEY, JSON.stringify(hist));

  } catch {

    /* quota */

  }

}



export function ivRankFromHistory(symbol, currentIv) {

  const hist = loadIvHistory()[String(symbol).toUpperCase()];

  if (!hist || currentIv == null) return null;

  const vals = Object.values(hist).filter((v) => typeof v === "number");

  if (vals.length < 120) return null;

  const min = Math.min(...vals);

  const max = Math.max(...vals);

  if (max <= min) return 50;

  return Math.round(((currentIv - min) / (max - min)) * 100);

}



/**

 * @param {object} p — earningsDaysAway, hv20, chainIv30, symbol

 */

export function evaluateOptionsChecks(p) {

  const days = p.earningsDaysAway ?? p.earningsState?.daysAway ?? null;

  const skipLocal = p.skipLocalIvSave === true;

  const sym = p.symbol != null ? String(p.symbol).toUpperCase() : "";

  const equity = p.isEarningsEquity ?? (sym ? isEarningsEquity(sym) : false);

  let optionsBlock = false;

  let optionsAdvisory = null;

  let optionsFlag = "";



  if (equity && days == null) {

    optionsFlag = "earnings_unknown";

  } else if (typeof days === "number" && days >= 0 && days <= 21) {

    optionsFlag = days <= 10 ? "earnings_soon" : "earnings_advisory";

  }



  let ivHvRatio = null;

  if (p.chainIv30 != null && p.hv20 != null && p.hv20 > 0) {

    ivHvRatio = p.chainIv30 / p.hv20;

    if (ivHvRatio > 1.5) {

      optionsAdvisory = "Options expensive (IV vs HV)";

      optionsFlag = optionsFlag || "iv_expensive";

    }

  } else if (p.chainIv30 == null) {

    optionsFlag = optionsFlag || "iv_unavailable";

  }



  if (!skipLocal && p.symbol && p.chainIv30 != null) saveIvDaily(p.symbol, p.chainIv30);



  return {

    earningsDays: days,

    ivHvRatio,

    ivRank: p.ivRank ?? (p.symbol && !skipLocal ? ivRankFromHistory(p.symbol, p.chainIv30) : null),

    optionsBlock,

    optionsAdvisory,

    optionsFlag,

    earningsUnknown: equity && days == null,

  };

}


